module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$root.$data.cart) ? _c('div', [_c('div', {
    staticClass: "px2 mb3"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary right",
    attrs: {
      "disabled": _vm.$root.$data.cart.items.length == 0
    },
    on: {
      "click": function($event) {
        _vm.goToCheckout()
      }
    }
  }, [_vm._v("Gå til kassen")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised right",
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("Tilbake")]), _vm._v(" "), _c('div', {
    staticClass: "fz24 light mt2"
  }, [_vm._v("Handlekurv")]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb2"
  }, [_vm._v("Du har " + _vm._s(_vm.$root.$data.cart.items.length) + " varer i handlekurven.")])], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "clearfix relative"
  }, [(_vm.state.is('emptying-cart')) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$root.$data.cart.items.length > 0) ? _c('div', {
    staticClass: "card rounded sh1"
  }, [_c('table', {
    staticClass: "cart-table",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.$root.$data.cart.items), function(cartItem, index) {
    return _c('tr', {
      staticClass: "@bg-light-blue"
    }, [_c('td', {
      staticClass: "cell-image p2"
    }, [_c('img', {
      staticClass: "rounded pointer",
      attrs: {
        "src": _vm.getThumbnail(cartItem.product),
        "width": "80",
        "height": "80"
      },
      on: {
        "click": function($event) {
          _vm.viewProduct(cartItem.product.id)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "fz18 mb1 text-blue pointer",
      on: {
        "click": function($event) {
          _vm.viewProduct(cartItem.product.id)
        }
      }
    }, [_vm._v(_vm._s(cartItem.product.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(cartItem.parameters_text))])]), _vm._v(" "), _c('td', [_c('myo-input', {
      staticClass: "center",
      nativeOn: {
        "change": function($event) {
          _vm.updateItem(index)
        }
      },
      model: {
        value: (cartItem.quantity),
        callback: function($$v) {
          _vm.$set(cartItem, "quantity", $$v)
        },
        expression: "cartItem.quantity"
      }
    })], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "fz24 light text-grey truncate"
    }, [_vm._v("kr " + _vm._s(_vm.toLocale(cartItem.unit_price / 100)) + ",-")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "fz24 light text-blue truncate"
    }, [_vm._v("kr " + _vm._s(_vm.toLocale(cartItem.total / 100)) + ",-")])]), _vm._v(" "), _c('td', {
      staticClass: "cell-actions center"
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.removeItem(index)
        }
      }
    }, [_c('md-icon', [_vm._v("close")])], 1)], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix flex border-top border-light-grey"
  }, [_c('div', {
    staticClass: "flex-auto p1"
  }, [_c('md-button', {
    nativeOn: {
      "click": function($event) {
        _vm.emptyCart()
      }
    }
  }, [_vm._v("Tøm handlekurven")])], 1), _vm._v(" "), _c('div', {
    staticClass: "p3"
  }, [_c('div', {
    staticClass: "fz24 light mb1 text-grey truncate"
  }, [_vm._v("kr " + _vm._s(_vm.toLocale(_vm.$root.$data.cart.net_total / 100)) + ",-")]), _vm._v(" "), _c('div', {
    staticClass: "text-grey"
  }, [_vm._v("Total eksl. MVA")])]), _vm._v(" "), _c('div', {
    staticClass: "p3"
  }, [_c('div', {
    staticClass: "fz24 light mb1 text-grey truncate"
  }, [_vm._v("kr " + _vm._s(_vm.toLocale(_vm.$root.$data.cart.vat_total / 100)) + ",-")]), _vm._v(" "), _c('div', {
    staticClass: "text-grey"
  }, [_vm._v("MVA")])]), _vm._v(" "), _c('div', {
    staticClass: "p3"
  }, [_c('div', {
    staticClass: "fz24 light mb1 text-blue truncate"
  }, [_vm._v("kr " + _vm._s(_vm.toLocale(_vm.$root.$data.cart.gross_total / 100)) + ",-")]), _vm._v(" "), _c('div', {
    staticClass: "text-grey"
  }, [_vm._v("Total inkl. MVA")])])])]) : _vm._e(), _vm._v(" "), (_vm.$root.$data.cart.items.length == 0) ? _c('div', {
    staticClass: "card rounded sh1"
  }, [_c('div', {
    staticClass: "p3 center"
  }, [_c('div', {
    staticClass: "fz24 light my3"
  }, [_vm._v("Ingen varer i handlekurven...")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.goToShop()
      }
    }
  }, [_vm._v("Klikk her for å handle")])], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "px2 my3"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary right",
    attrs: {
      "disabled": _vm.$root.$data.cart.items.length == 0
    },
    on: {
      "click": function($event) {
        _vm.goToCheckout()
      }
    }
  }, [_vm._v("Gå til kassen")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised right",
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("Tilbake")]), _vm._v(" "), _c('div', {
    staticClass: "fz24 light mt2"
  }, [_vm._v("Handlekurv")]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb2"
  }, [_vm._v("Du har " + _vm._s(_vm.$root.$data.cart.items.length) + " varer i handlekurven.")])], 1)]) : _c('div', {
    staticClass: "p3 center"
  }, [_c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-grey "
  }, [_c('th', {
    staticClass: "border-bottom border-light-grey "
  }), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light left-align"
  }, [_vm._v("Produkt")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light"
  }, [_vm._v("Antall")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light left-align"
  }, [_vm._v("Pris pr. stk.")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light left-align",
    attrs: {
      "light": ""
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light"
  }, [_vm._v("Handlinger")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04206286","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/views/shop/Cart.vue
// module id = 634
// module chunks = 1